import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DATE_FORMAT_CLIENT_PARAMS, DATE_TIME_FORMAT_CLIENT, ROLES } from '../../helpers/constants'
import { useTranslation } from 'react-i18next'
import { Button, Space } from 'antd'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
// @ts-ignore
import ReactExport from 'react-data-export'
import moment from 'moment'
import { useRef, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx'
import { cloneDeep, groupBy, isError, reduce, set } from 'lodash'
import PreviewFileImport from './PreviewFileImport'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const ExportToCSV = observer((props: any) => {
   const { from: fromDate, to: toDate, getData } = props
   const { t } = useTranslation()
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   const ProductStore = useStore('ProductStore')

   const exportRef = useRef(null)
   const inputFileRef = useRef(null)
   const [visiblePreviewImport, setVisiblePreviewImport] = useState(false)
   const [selectedRow, setSelectedRow] = useState<any[]>([])
   const [dataInsert, setDataInsert] = useState<any>(null)

   const handleInputFile = () => {
      if (inputFileRef.current !== null) {
         // @ts-ignore
         inputFileRef.current!.click()
      }
   }

   const handleImportCSV = async (event: any) => {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = async (e: any) => {
         const data = new Uint8Array(e.target.result)
         const workbook = XLSX.read(data, { type: 'array' })
         const sheetName = workbook.SheetNames[0]
         const rawWorksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: [
               'role',
               'productId',
               'baseCost',
               'shippingFee',
               'additionalItemShippingFee',
               'packingFee',
               'handingFee',
               'labelFee'
            ],
            raw: false,
            defval: ''
         })

         // Xử lý từng dòng để thay thế null/undefined bằng chuỗi rỗng
         const worksheet = rawWorksheet.map((row: any) => {
            const processedRow = {} as any
            Object.keys(row).forEach((key) => {
               processedRow[key] = row[key] === null || row[key] === undefined ? '' : row[key]
            })
            return processedRow
         })
         worksheet.splice(0, 1) // Xóa dòng tiêu đề nếu có
         // setSelectedRow(cloneDeep(worksheet))
         console.log('====================================')
         console.log('dataRows', worksheet)
         console.log('====================================')

         setDataInsert(cloneDeep(worksheet))

         const dataResponse = await ProductStore.previewListPrice(cloneDeep(worksheet))

         if (dataResponse?.code == 200) {
            // dataRows = dataRows.map((row: any) => {
            //    const found = dataResponse.data.find((d: any) => d.sellerOrderId == row.sellerOrderId)
            //    if (found && found?.isError) {
            //       return {
            //          ...row,
            //          isError: true,
            //          errorMessage: found.errorMessage
            //       }
            //    }
            //    return row
            // })
            setSelectedRow(dataResponse?.data)
         }

         setVisiblePreviewImport(true)
      }
      reader.readAsArrayBuffer(file)
   }

   return (
      <Space>
         {data_getUserInfo?.role == ROLES.ADMIN && (
            <Button className="btn-add" onClick={handleInputFile}>
               {'Nhập Excel'}
            </Button>
         )}

         <div style={{ display: 'none' }}>
            <input ref={inputFileRef} type="file" accept=".xlsx, .xls" onChange={handleImportCSV} />
         </div>

         {visiblePreviewImport && (
            <PreviewFileImport
               items={selectedRow}
               visible={visiblePreviewImport}
               onOk={() => {
                  setVisiblePreviewImport(false)
                  if (inputFileRef.current) {
                     ;(inputFileRef.current as HTMLInputElement).value = ''
                  }
                  getData?.()
               }}
               onCancel={() => {
                  setVisiblePreviewImport(false)
                  if (inputFileRef.current) {
                     ;(inputFileRef.current as HTMLInputElement).value = ''
                  }
               }}
               dataInsert={dataInsert}
            />
         )}
      </Space>
   )
})

export default ExportToCSV
